import { Caption1, makeStyles, tokens } from '@fluentui/react-components'
import { requestorNames } from '../lib/labels'
import type { Demand } from '../types/demand'

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS },
})

export function OpportunitySummary({ demand, matchedSkills }: {
  demand: Demand
  matchedSkills?: string[]
}) {
  const styles = useStyles()
  // Only what was recorded — a line of "not specified" says nothing.
  const commitment = [
    demand.hours_per_week != null ? `${demand.hours_per_week} h/week` : null,
    demand.duration?.trim() || null,
  ].filter(Boolean).join(' · ')
  return (
    <div className={styles.root} aria-label="Opportunity at a glance">
      {commitment && (
        <Caption1>
          <strong>Commitment: </strong>{commitment}
        </Caption1>
      )}
      <Caption1>
        <strong>Contact: </strong>
        {demand.caretaker_name || requestorNames(demand.requestor_name) || 'Not yet assigned'}
      </Caption1>
      {/* Which skills matched, when any did. The fit bar and the page say the rest. */}
      {matchedSkills && matchedSkills.length > 0 && (
        <Caption1>Skills you bring: {matchedSkills.join(', ')}.</Caption1>
      )}
    </div>
  )
}
